import Link from "next/link";
import { Balancer } from "react-wrap-balancer";
import { MAIN_ROUTES, CLOUD_SERVICES_ROUTES } from "@/constants/routes";

export const FOOTER_CONSTANTS = {
  text1: (
    <>
      Note : All Bundles Require a 12 Month Commitment .
      <br />
      <Balancer>
        Pricing is fully customized based on your user count and governance needs. Check
        our dedicated page{" "}
        <Link
          href={`${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MICROSOFT_365}`}
          style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
        >
          Managed Microsoft 365
        </Link>{" "}
        to get a better understanding of our offerings and the services included.
      </Balancer>
    </>
  ),
  btnText: "Get Started Now",
};
